import { validateCPF } from "@/utils/validateCPF";
import * as Yup from 'yup';

export const CpfValidation = Yup.object().shape({
    cpf: Yup.string()
    .required("CPF é necessário")
    .test("valid-cpf", "CPF Inválido", (value) => validateCPF(value || "")),
});